/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    export class MeevoMessengerMessageCounter implements angular.IDirective {
        restrict = 'E';
        scope = {
            messageLengthLimit: '=',
            messageText: '=',
            activeMessenger: '='
        };

        templateUrl = 'app/plugins/meevoMessenger/directives/messageCounter/meevoMessengerMessageCounter.html';
        constructor() { }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            const getMessageLengthInfo = () => {
                const messageLengthInfo = Meevo.Plugins.MeevoMessenger.calculateSmsLength(scope.messageText, scope.messageLengthLimit);

                scope.charactersLeft = messageLengthInfo.remainingCharacterCount;
                scope.segmentCount = getSegmentCount(messageLengthInfo.segmentCount);
            }

            const getSegmentCount = (segmentCount: number) => {
                return scope.activeMessenger === MessengersEnum.MeevoMessengerTwoWaySms && segmentCount > 1
                    ? segmentCount : null;
            }

            scope.$watch('messageText', function (value) {
                if (!value) {
                    scope.charactersLeft = scope.messageLengthLimit;
                    scope.segmentCount = 0;
                    return
                }
                getMessageLengthInfo();
            });           
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoMessengerMessageCounter();
            };

            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('meevoMessengerMessageCounter', MeevoMessengerMessageCounter.factory());
}
